export default () => ({
  root: {
    height: '100%',
    overflow: 'hidden',
    position: 'absolute',
    background: '#37474f',
  },
});
